import { Button, Divider, Group, Stack, Text } from "@mantine/core";
import { useState } from "react";
import FilterBlockRoot from "../FilterBlockRoot";
import { IconArrowDown, IconX } from "@tabler/icons-react";
import FilterList from "../FilterList";
import { useLanguage } from "../../../stores/LanguageStore";
import FilterBlockRootMobile from "./FilterBlockRootMobile";
import FilterListMobile from "./FilterListMobile";

const FilterContentMobile = ({
  mainFilter,
  setMainFilter,
  id,
  fields,
  getFieldOptionName,
  isClient,
  disableBottomButtons,
  maxHeight,
  pageName,
  defaultFiltersClose = false,
  buttonLoading,
  disableFilters,
  disableEdit,
  message,
  savedFiltersReadonly,
}) => {
  const lang = useLanguage((s) => s.language);
  const [loadingSaver, setLoadingSaver] = useState(true);
  const [filter, setFilter] = useState(mainFilter);

  const onSaved = (newFilter) => {
    setLoadingSaver(true);
  };

  const onChange = (newFilter) => {
    setMainFilter(newFilter);
  };

  return (
    <Stack w={"100%"} align="stretch" h={"78vh"} gap={0}>
      <Group pos={"relative"} align="start" h={"auto"}>
        <FilterBlockRootMobile
          filter={filter}
          maxHeight={maxHeight}
          id={id}
          setFilter={setFilter}
          fields={fields}
          getFieldOptionName={getFieldOptionName}
          isClient={isClient}
          submitFilter={onChange}
          maxItems={50}
          disableButtons={disableBottomButtons}
          onSaved={onSaved}
          pageName={pageName}
          buttonLoading={buttonLoading}
          disableEdit={disableEdit}
          message={message}
        />
      </Group>
      <Divider my={16} />
      <Text mb={8}>{lang.table.toolbar.filter.saved_filters} :</Text>
      {!disableEdit && !disableFilters && (
        <FilterListMobile
          loading={loadingSaver}
          setLoading={setLoadingSaver}
          handleFilter={setFilter}
          pageName={pageName}
          fields={fields}
          savedFiltersReadonly={savedFiltersReadonly}
        />
      )}
    </Stack>
  );
};

export default FilterContentMobile;
